import React from 'react';
import InBoundTaskBoard from '../TaskAllocation/InBoundTaskBoard';

const InBoundTaskAllocation = ({ user, selectedCountry = 'all' }) => {
  return <InBoundTaskBoard user={user} selectedCountry={selectedCountry} />;
};

export default InBoundTaskAllocation;